var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1 5.7c-9.1 0-16.5 7.4-16.5 16.5l0 15 -5.5-5.5c-0.4-0.4-0.9-0.4-1.2 0 -0.4 0.4-0.4 0.9 0 1.2l6.9 6.9c0.2 0.2 2 0.3 2.2 0.3 0.2 0 0.4-0.1 0.6-0.3l6.9-6.9c0.4-0.4 0.4-0.9 0-1.2 -0.4-0.4-1.1-0.4-1.5 0l-5.5 5.5 0-15c0-8.1 6.7-13.2 14.8-13.2l7.2 0c0.5 0 2.2-1 2.2-1.5 0-0.5-2-1.9-2.5-1.9l-8.2 0 0 0Zm24.4 0.2c-0.5 0-0.9 0.4-0.9 0.9l0 40.1c0 0.5 0.4 0.9 0.9 0.9l40.1 0c0.5 0 0.9-0.4 0.9-0.9l0-40.1c0-0.5-0.4-0.9-0.9-0.9l-40.1 0Zm2.6 3.2l35 0 0 35 -35 0 0-35Zm-49.5 43.3c-0.5 0-0.9 0.4-0.9 0.9l0 40.1c0 0.5 0.4 0.9 0.9 0.9l40.1 0c0.5 0 0.9-0.4 0.9-0.9l0-40.1c0-0.5-0.4-0.9-0.9-0.9l-40.1 0Zm2.5 3.7l35 0 0 35 -35 0 0-35Zm75.8 3.8c-0.2 0-0.5 0.1-0.6 0.2l-6.9 6.9c-0.4 0.4-0.4 0.9 0 1.2 0.4 0.4 0.9 0.4 1.2 0l5.5-5.5 0 15c0 8.1-6.7 14.2-14.8 14.2l-7.2 0c-0.5 0-1.9 1-1.9 1.5 0 0.5 1.2 1.5 1.7 1.5l9.2 0c9.1 0 16.5-8.1 16.5-17.2l0-15 5.5 5.5c0.2 0.2 0.4 0.3 0.6 0.3 0.2 0 0.4-0.1 0.6-0.3 0.4-0.4 0.4-0.9 0-1.2l-6.9-6.9c-0.1-0.1-2.2-0.2-2.5-0.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParser);
export default __webpack_public_path__ + "static/media/parser.9103aabff800f84ea1a6c2bc154c9136.svg";
export { ForwardRef as ReactComponent };